import { backUrl } from "../utils/backURL";
import { fetchWrapper } from "../utils/fetchWrapper";

/**
 * Creates a file and attaches it to an entity
 * @param {string} clientId - The client ID
 * @param {Object} fileData - File information including name, original_name, file_path, file_size, mime_type, file_type
 * @param {string} entityTable - The table name of the entity to attach the file to
 * @param {string} entityId - The ID of the entity to attach the file to
 * @param {Object} metadata - Additional metadata for the file attachment (optional, defaults to empty object)
 * @param {string} token - Authentication token
 * @returns {Promise<Object>} Response with the created file data
 */
export const createFileAndAttach = async (
  clientId,
  fileData,
  entityTable,
  entityId,
  token
) => {
  const res = await fetchWrapper(
    `${backUrl}/workflows/p2p/${clientId}/files-and-attach`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        fileData,
        entityTable,
        entityId,
      }),
    }
  );

  return res;
};
